import React, { Component } from 'react';
import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs';
import '../Technical.css';
import Tabs from '../../shared/tabs/Tabs';
import Pane from '../../shared/pane/Pane';
import rubyScript from './Ruby.js';
import powershellScript from './Powershell.js';
import cSharpScript from './CSharp.js';

class ImageDeliveryScript extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                        Image Delivery Script</h1>
                    <div className="technical-main-content">
                    <p>Please find below some sample Image Delivery scripts:</p>
                        <Tabs selected={0}>
                            <Pane label="Ruby">
                                <div><pre className="tab-content-pre">{rubyScript}</pre></div>
                            </Pane>
                            <Pane label="Powershell">
                                <div><pre className="tab-content-pre">{powershellScript}</pre></div>
                            </Pane>
                            <Pane label="C#">
                                <div><pre className="tab-content-pre">{cSharpScript}</pre></div>
                            </Pane>
                        </Tabs>
                    </div>
                </div>
            </div>
        )
    }
}

export default ImageDeliveryScript;